<template>
  <v-app-bar flat absolute rounded="0" :height="$vuetify.display.xs ? 56 : 76" class="first-top-bar px-2 px-sm-5 px-md-10">
    <!-- TODO: Show this button only on the /nodes/:id route -->
    <v-btn
      v-if="$vuetify.display.xs"
      @click="toggleSidemenu()"
      class="mx-1"
      height="48px"
      width="48px"
      elevation=0
      size="large" icon tile
    >
      <v-icon class="mr-0" size="28px">mdi-view-split-horizontal</v-icon>
    </v-btn>

    <router-link v-bind:to="getHeaderLink" class="main-logo mx-1" :aria-label="$t('menus.topBars.home')">
      <img alt="TubeWay Logo" v-if="this.getDarkMode" src="../../../../assets/images/tw-main-logo-dark.png"/>
      <img alt="TubeWay Logo" v-if="!this.getDarkMode" src="../../../../assets/images/tw-main-logo-light.png"/>
    </router-link>

    <v-spacer/>

    <Breadcrumb v-if="!showingBackToFilesButton && $vuetify.display.smAndUp"/>

    <div v-if="showingBackToFilesButton">
      <v-btn
        v-if="currentNode"
        :to="'/node/' + currentNode.id"
        class="mx-1 bg-primary"
        :size="$vuetify.display.xs ? 'x-small' : 'large'"
        height="48px"
        elevation=0
      >
        <v-icon>mdi-keyboard-backspace</v-icon>
        <span v-if="!$vuetify.display.xs">
          {{ $t('layouts.main.backToFiles') }}
        </span>
      </v-btn>
    </div>

    <v-spacer v-if="$vuetify.display.smAndUp"></v-spacer>

    <v-btn
      v-if="$vuetify.display.mdAndUp"
      class="mx-1 bg-primary"
      elevation=0
      to="/console/index"
      data-cy="topbar-managementConsole-button"
    >
      <v-icon>mdi-tune-vertical</v-icon>
      {{ $t('layouts.main.managementConsole') }}
    </v-btn>

    <AnnouncementsButton v-if="hasUndismissedAnnouncements" ref="announcementsButton" />
    <DownloadsMenu />
    <NotificationsMenu/>
    <BeeUserMenu :forceManagementConsole="false"/>
  </v-app-bar>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useMainStore } from '@/stores/MainStore.js'
import { useNodeStore } from '@/stores/NodeStore.js'
import { useAnnouncementStore } from '@/stores/AnnouncementStore.js'
import Breadcrumb from './Breadcrumb.vue';
import BeeUserMenu from './BeeUserMenu.vue';
import NotificationsMenu from './notifications/NotificationsMenu.vue';
import DownloadsMenu from './downloads/DownloadsMenu.vue';
import AnnouncementsButton from './announcements/AnnouncementsButton.vue';

export default {
  name: 'NodesTopBar',
  components: {
    Breadcrumb,
    BeeUserMenu,
    NotificationsMenu,
    DownloadsMenu,
    AnnouncementsButton,
  },
  props: {},
  data: function () {
    return {};
  },
  mounted: function () {
  },
  watch: {
    shouldAutoShowAnnouncements: {
      async handler(newValue) {
        if (newValue) {
          await this.$nextTick();
          this.openAnnouncementsDialog();
        }
      },
      immediate: true,
    },
  },
  methods: {
    toggleSidemenu() {
      const mainStore = useMainStore();
      mainStore.toggleSidemenu();
    },
    openAnnouncementsDialog(retries = 5) {
      const announcementStore = useAnnouncementStore();
      if (this.$refs.announcementsButton) {
        announcementStore.consumeAutoShow();
        this.$refs.announcementsButton.openDialog();
      } else if (retries > 0) {
        setTimeout(() => this.openAnnouncementsDialog(retries - 1), 1000);
      } else {
        announcementStore.consumeAutoShow();
      }
    },
  },
  computed: {
    getDarkMode() {
      const mainStore = useMainStore();
      return mainStore.getDarkMode;
    },
    currentNode: function () {
      const nodeStore = useNodeStore();
      return nodeStore.getCurrentNode;
    },
    getRootNodeId() {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
    getHeaderLink: function () {
      if (this.getRootNodeId) {
        return '/node/' + this.getRootNodeId;
      }

      return '/';
    },
    showingBackToFilesButton() {
      return this.$route.path.startsWith('/recycle-bin');
    },
    hasUndismissedAnnouncements() {
      const announcementStore = useAnnouncementStore();
      return announcementStore.hasVisibleAnnouncements;
    },
    shouldAutoShowAnnouncements() {
      const announcementStore = useAnnouncementStore();
      return announcementStore.shouldAutoShowDialog;
    },
  },
};
</script>
